'use client'

import {Products} from "@/app/enums/Products";
import {useMemo, useState} from "react";
import dynamic from "next/dynamic";

const CallbackModal = dynamic(() => import("../../pageModels/healthLanding/components/CallbackModal"));

const boxData = [
    {
        product: Products.LOAN_INSURANCE,
        wording: 'Besoin de conseils ?',
        subwording: 'Votre conseiller dédié',
        phone: '01 82 83 36 33',
    },
]

export default function CallBlock({product}: {product?: string}) {
    const [isModalOpen, setIsModalOpen] = useState(false)

    const box = useMemo(() => {
        if (product === Products.HEALTH || product === Products.HEALTH_COMPARATOR) {
            return {
                product: Products.HEALTH,
                wording: 'Besoin de conseils ?',
                subwording: 'Contactez un expert',
                phone: '',
            }
        }

        return boxData.find((item) => item.product === product) ?? boxData[0]
    }, [product]);

    return (
        <div
            className="flex flex-col px-6 py-4 mx-auto gap-4 bg-rm-blue/20 border rounded-2xl border-rm-blue shrink-0 md:mt-[45px] h-fit w-full md:w-fit"
        >
            <p className="flex flex-col">
                <strong>{box.wording}</strong> {box.subwording}
            </p>

            {box.phone && (
                <div className="flex items-center gap-4">
                    <a
                        href={`tel:${box.phone.replace(/\s/g, '')}`}
                        className="p-2 bg-rm-blue text-white rounded-lg hover:shadow hover:bg-rm-blue/80"
                    >
                        <i className="fas fa-phone pr-2" />
                        {box.phone.replace(/(\d{2})(?=\d)/g, '$1 ')}
                    </a>

                    <span className="text-rm-blue-deep text-rm-12">(appel gratuit)</span>
                </div>
            )}

            {!box.phone && (
                <>
                    <button
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            setIsModalOpen(true);
                        }}
                        className="p-2 bg-rm-blue text-white rounded-lg hover:shadow hover:bg-rm-blue/80 w-fit"
                    >
                        <i className="fas fa-phone pr-2" />
                        Appel gratuit
                    </button>

                    {isModalOpen && (
                        <CallbackModal
                            modalName={"health_callback_modal"}
                            isOpen={true}
                            closeModal={() => setIsModalOpen(false)}
                            productType={Products.HEALTH}
                        />
                    )}
                </>
            )}
        </div>
    )
}
